const CHANGE_VALUE_SUCCESS = 'fulcrum/containers/Form/NotebookPanel/CHANGE_VALUE_SUCCESS'
const ADD_PANEL = 'fulcrum/container/Form/NotebookPanel/ADD_PANEL'
const REMOVE_PANEL = 'fulcrum/container/Form/NotebookPanel/REMOVE_PANEL'
const UPDATE_RESOLUTION_VALUE = 'fulcrum/container/Form/NotebookPanel/UPDATE_RESOLUTION_VALUE'
const UPDATE_SIZE_VALUE = 'fulcrum/container/Form/NotebookPanel/UPDATE_SIZE_VALUE'
const UPDATE_VENDOR_VALUE = 'fulcrum/container/Form/NotebookPanel/UPDATE_VENDOR_VALUE'
const UPDATE_PART_NUMBER_VALUE = 'fulcrum/container/Form/NotebookPanel/UPDATE_PART_NUMBER_VALUE'
const UPDATE_REFRESH_RATE_VALUE = 'fulcrum/container/Form/NotebookPanel/UPDATE_REFRESH_RATE_VALUE'
const CHANGE_RESOLUTION_VALUE = 'fulcrum/container/Form/NotebookPanel/CHANGE_RESOLUTION_VALUE'
const CHANGE_SIZE_VALUE = 'fulcrum/container/Form/NotebookPanel/CHANGE_SIZE_VALUE'
const CHANGE_VENDOR_VALUE = 'fulcrum/container/Form/NotebookPanel/CHANGE_VENDOR_VALUE'
const CHANGE_PART_NUMBER_VALUE = 'fulcrum/container/Form/NotebookPanel/CHANGE_PART_NUMBER_VALUE'
const CHANGE_REFRESH_RATE_VALUE = 'fulcrum/container/Form/NotebookPanel/CHANGE_REFRESH_RATE_VALUE'
const ADD_PANEL_START = 'fulcrum/container/Form/NotebookPanel/ADD_PANEL_START'
const REMOVE_PANEL_START = 'fulcrum/container/Form/NotebookPanel/REMOVE_PANEL_START'

export {
  CHANGE_VALUE_SUCCESS,
  ADD_PANEL,
  REMOVE_PANEL,
  UPDATE_RESOLUTION_VALUE,
  UPDATE_SIZE_VALUE,
  UPDATE_VENDOR_VALUE,
  UPDATE_PART_NUMBER_VALUE,
  CHANGE_RESOLUTION_VALUE,
  CHANGE_SIZE_VALUE,
  CHANGE_VENDOR_VALUE,
  CHANGE_PART_NUMBER_VALUE,
  ADD_PANEL_START,
  REMOVE_PANEL_START,
  CHANGE_REFRESH_RATE_VALUE,
  UPDATE_REFRESH_RATE_VALUE,
}
